import { CheckCircle2, XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'motion/react';

import { Button } from '@/components/ui/button';

export function ClearButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="absolute top-1/2 right-2 -translate-y-1/2 cursor-pointer rounded-sm p-0.5 text-muted-foreground opacity-70 transition-opacity hover:opacity-100"
      aria-label="Clear"
    >
      <XIcon className="h-3.5 w-3.5" />
    </button>
  );
}

export function FormFieldError({ id, error }: { id: string; error?: string }) {
  return (
    <AnimatePresence>
      {error && (
        <motion.p
          id={id}
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          className="mt-1 text-xs text-destructive"
          role="alert"
        >
          {error}
        </motion.p>
      )}
    </AnimatePresence>
  );
}

export function SuccessState({
  title,
  subtitle,
  onClose,
}: {
  title: string;
  subtitle: string;
  onClose: () => void;
}) {
  return (
    <motion.div
      key="success"
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0 }}
      className="flex min-h-0 flex-1 flex-col"
    >
      <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-4 text-center">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', stiffness: 200, damping: 15, delay: 0.1 }}
          className="relative"
        >
          <motion.div
            className="absolute inset-0 -m-3 rounded-full bg-success/20"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1.5, opacity: [0, 0.6, 0] }}
            transition={{ duration: 1.2, delay: 0.3 }}
          />
          <CheckCircle2 className="h-16 w-16 text-success" />
        </motion.div>
        <div>
          <h3 className="text-xl font-semibold">{title}</h3>
          <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>
        </div>
      </div>
      <div className="shrink-0 pt-4">
        <Button onClick={onClose} className="w-full">
          Close
        </Button>
      </div>
    </motion.div>
  );
}
